<div class="top-container">
    <button
        mat-raised-button
        class="primary-button"
        aria-label="Définir l'ordre des étapes"
        matTooltip="Définir l'ordre des étapes"
        matTooltipPosition="below"
        (click)="sortSteps()">
        <fa-icon [icon]="sortStepsIcon"></fa-icon>
        Définir l'ordre des étapes
    </button>
    <button mat-raised-button class="primary-button" aria-label="recharger le workflow" matTooltip="Recharger le workflow" matTooltipPosition="below" (click)="load()">
        <fa-icon [icon]="reloadIcon"></fa-icon>
        Recharger
    </button>
    <button mat-raised-button class="accent-button" aria-label="Sauver le workflow" matTooltip="Sauver le workflow" matTooltipPosition="below" (click)="save()">
        <fa-icon [icon]="saveIcon"></fa-icon>
        Enregistrer
    </button>
    <button
        mat-raised-button
        class="accent-button"
        aria-label="Activer le workflow"
        matTooltip="Activer le workflow"
        matTooltipPosition="below"
        [disabled]="!activationEnabled"
        (click)="activate()">
        <fa-icon [icon]="activateIcon"></fa-icon>
        Activer
    </button>
</div>
<div class="bottom-container">
    <ng-template nodeFormHost></ng-template>
    @if (selection?.selectedNode || selection?.selectedConnection || selection?.selectedSocket) {
        <button mat-raised-button class="accent-button" (click)="fillData()" [disabled]="!currentForm.isDirty">Appliquer</button>
    }
    <ngx-spinner name="detail-bar-spinner" bdColor="var(--avm-color-30)" color="var(--spinner-color)" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</div>
